'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Hamburger = require('./Hamburger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header(props) {
    var _this, _this2;

    (0, _classCallCheck3.default)(this, Header);

    _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props)), _this2);

    _this2.handleScroll = function (event) {
      var scrollAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var transparent = _this.state.transparent;
      var atTop = (scrollAmount || window.pageYOffset || document.documentElement.scrollTop) <= 5;

      if (transparent !== atTop) {
        _this.setState({ transparent: atTop });
      }
    };

    _this2.state = {
      transparent: props.isTransparentWhenAtScrollTop
    };
    return _this2;
  }

  (0, _createClass3.default)(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isTransparentWhenAtScrollTop) {
        this.installScrollHandler();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var isTransparentWhenAtScrollTop = this.props.isTransparentWhenAtScrollTop;


      if (isTransparentWhenAtScrollTop) {
        this.installScrollHandler();
      } else {
        this.uninstallScrollHandler();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.uninstallScrollHandler();
    }
  }, {
    key: 'installScrollHandler',
    value: function installScrollHandler() {
      if (!this.scrollHandler) {
        this.scrollHandler = this.handleScroll;
        if (__CLIENT__ || __TEST__) {
          window.addEventListener('scroll', this.scrollHandler, true);
        }
        this.handleScroll();
      }
    }
  }, {
    key: 'uninstallScrollHandler',
    value: function uninstallScrollHandler() {
      if (this.state.transparent) {
        this.setState({ transparent: false });
      }
      if (this.scrollHandler) {
        if (__CLIENT__ || __TEST__) {
          window.removeEventListener('scroll', this.scrollHandler, true);
        }
        this.scrollHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isDark = _props.isDark,
          isMobile = _props.isMobile,
          showHamburger = _props.showHamburger,
          dropdownOpen = _props.dropdownOpen,
          onDropdownStateToggled = _props.onDropdownStateToggled,
          isTransparentWhenAtScrollTop = _props.isTransparentWhenAtScrollTop;
      var transparent = this.state.transparent;


      var dropdownOpenOnMobile = dropdownOpen && isMobile;

      return _react2.default.createElement(
        'header',
        {
          className: (0, _classnames2.default)('header', {
            'header--can-be-transparent': isTransparentWhenAtScrollTop && !dropdownOpenOnMobile,
            'header--transparent': transparent && !dropdownOpenOnMobile,
            'header--dark': isDark
          })
        },
        _react2.default.createElement(
          'h1',
          { className: 'header__logo' },
          _react2.default.createElement(
            'a',
            { href: '/' },
            'ClassPass'
          )
        ),
        children,
        showHamburger && _react2.default.createElement(_Hamburger.Hamburger, {
          open: dropdownOpen,
          onClick: onDropdownStateToggled,
          className: 'lg-hidden'
        })
      );
    }
  }]);
  return Header;
}(_react.Component);

Header.propTypes = {
  onDropdownStateToggled: _propTypes2.default.func,
  isDark: _propTypes2.default.bool,
  isTransparentWhenAtScrollTop: _propTypes2.default.bool,
  showHamburger: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  dropdownOpen: _propTypes2.default.bool,
  children: _propTypes2.default.node
};